export const extractInitials = (firstName: string, lastName: string): string => {
    let result = '?';
    if (!(firstName || lastName)) {
        return result;
    }
    if (!lastName) {
        result = firstName?.toString().substring(0, 2);
    } else if (!firstName) {
        result = lastName?.toString().substring(0, 2);
    } else {
        result = firstName?.toString().substring(0, 1) + lastName?.toString().substring(0, 1);
    }
    return result.toLocaleUpperCase();
};
